<template>
	<div v-if="isShow" class="profile-subscription-paused-bar flex justify-center items-center">
		{{ $tc('profile.subscriptionPausedBar.subscriptionPausedText') }}&nbsp;
		<nuxt-link to="/profile/manage-plans/" class="text-underline">
			{{ $tc('login.clickHereText') }}
		</nuxt-link>
	</div>
</template>

<script>
export default {
	name: 'ProfileSubscriptionPausedBar',
	props: {
		isShow: {
			type: Boolean,
			required: true
		}
	}
}
</script>

<style lang="scss">
	.profile-subscription-paused-bar {
		position: absolute;
		left: 300px;
		top: 0;
		width: calc(100% - 300px - 40px);
		background-color: #fbfdda;
		color: #000000;
		font-size: 25px;
		font-weight: 500;
		padding: 20px 0;

		a {
			color: #000000;
			text-transform: lowercase;
		}

		@include respond-below(laptop) {
			position: static;
			width: 100%;
			font-size: 20px;
		}

		@include respond-below(phone) {
			font-size: 12px;
			padding: 10px;
		}
	}
</style>
